// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-company-contact-js": () => import("./../../../src/pages/company/contact.js" /* webpackChunkName: "component---src-pages-company-contact-js" */),
  "component---src-pages-ekyc-js": () => import("./../../../src/pages/ekyc.js" /* webpackChunkName: "component---src-pages-ekyc-js" */),
  "component---src-pages-facial-recognition-js": () => import("./../../../src/pages/facial-recognition.js" /* webpackChunkName: "component---src-pages-facial-recognition-js" */),
  "component---src-pages-image-recognition-js": () => import("./../../../src/pages/image-recognition.js" /* webpackChunkName: "component---src-pages-image-recognition-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-ocr-js": () => import("./../../../src/pages/ocr.js" /* webpackChunkName: "component---src-pages-ocr-js" */)
}

